// Logger utility - centralized logging for the application
// In production, these logs can be sent to a logging service
// For now, they are conditionally logged based on environment

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Log informational messages (only in development)
   */
  info: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log warning messages
   */
  warn: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Log error messages (always logged, but can be sent to error tracking service)
   */
  error: (message, error = null) => {
    // In production, this could be sent to Sentry, LogRocket, etc.
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.error('[ERROR]', message, error);
    }
    // TODO: In production, send to error tracking service
    // Example: Sentry.captureException(error);
  },

  /**
   * Log debug messages (only in development)
   */
  debug: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log('[DEBUG]', ...args);
    }
  }
};

export default logger;
